<article>
  <div class="header">
    <opac-progress-spinner [progress]="count$ | async" progressText="%">
      <opac-icon [class.completed]="challenge.progress >= challenge.target" icon="badge_challenge" size="2x"></opac-icon>
    </opac-progress-spinner>

    <span *ngIf="challenge.progress >= challenge.target" class="completed-title">
        {{ 'challenges.completed' | translate }}
      </span>
  </div>

  <div class="contents">
    <h3>
      <span>{{ 'challenges.challenge' | translate }}</span>

      <span>{{ challenge.name }}</span>

      <span *ngIf="challenge.progress >= challenge.target" class="completed-title">
        {{ 'challenges.completed' | translate }}
      </span>
    </h3>

    <span class="challenge-name" [class.content-expanded]="expanded">{{ challenge.name }}</span>

    <div *ngIf="expanded" @accordionTop class="main-content">
      <p>{{ getChallengeDescriptionLabel() | translate }}</p>

      <opac-button *ngIf="challenge.contents?.length > 0" (click)="showContents()">
        {{ 'button.viewContent' | translate }}
      </opac-button>
    </div>

    <div class="footer">
      <div class="content-progress">
        <span class="progress-title">{{ 'challenges.challengeProgress' | translate }}:</span>
        <span class="progress-content">{{ challenge.progress }}/{{ challenge.target }}</span>
        <span class="progress-label">{{ getChallengeProgressTitleLabel() | translate }}</span>
      </div>

      <div class="time-left">
        <opac-icon icon="clock"></opac-icon>
        <span class="days-left">{{ getDaysLeft() }}</span>
        <span class="days-left-text">&nbsp;{{ 'challenges.daysLeftTitle' | translate }}</span>
      </div>
    </div>

    <opac-button class="expander" [class.expanded]="expanded" (click)="toggleDescription()">
      <opac-icon icon="expand_more" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <div *ngIf="challenge.contents?.length > 0" class="controls">
    <opac-button (click)="showContents()">
      {{ 'button.viewContent' | translate }}
    </opac-button>
  </div>
</article>
